import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
  box: {
    marginTop: 15,
  },
  boxTitle: {
    fontSize: theme.fonts.sizes.font20PX,
    color: theme.colors.light.lightCyan,
  },
  boxQuestion: {
    fontSize: theme.fonts.sizes.font16PX,
    color: theme.colors.light.lightCyan,
    marginBottom: 5,
  },
}));
